import { UserProfile as ClerkUserProfile } from "@clerk/clerk-react";

export default function SettingsSecurity() {
  return (
    <div className="max-w-3xl">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Security</h1>
        <p className="text-sm text-gray-500 mt-1">
          Password changes, magic link preferences, connected sign-in methods,
          and active sessions are managed through your Clerk account portal.
        </p>
      </div>

      <ClerkUserProfile
        appearance={{
          elements: {
            card: "shadow-none border-0",
            navbar: "hidden",
          },
        }}
      />
    </div>
  );
}
